export default {
  None: false,
  Has: true,
};
